import type { RouteRecordRaw } from 'vue-router'

import { DISCOUNT } from './routes-names'

export default (): RouteRecordRaw[] => {
  return [
    {
      path: 'military-discount',
      name: DISCOUNT.MILITARY,
      component: () => import('~/scopes/cms/Landing.vue'),
      props: {
        simpleLayout: true,
      },
      meta: {
        owners: ['bot-squad-lifecycle-front'],
      },
    },
    {
      path: 'student-discount',
      name: DISCOUNT.STUDENT,
      component: () => import('~/scopes/cms/Landing.vue'),
      props: {
        simpleLayout: true,
      },
      meta: {
        owners: ['bot-squad-lifecycle-front'],
      },
    },
  ]
}
